<template>
    <div>
        <message-controller></message-controller>
        <navbar></navbar>
        <div class="container pt-4">
            <h1 class="title">
                Uživatelé
                <b-icon class="clickable" icon="plus-square-fill" variant="info"
                        @click="addNewItem()"></b-icon>

            </h1>

            <table class="table">
                <tbody>
                <tr v-for="item in posts.records" v-bind:key="item.id" v-bind:class="{ 'unavailable': item.available !== 1 }">
                    <td>
                        <h3 class="item-wrap" >
                            <div>{{item.name}}</div>
                            <div>
                                {{item.quantity}}
                                <b-icon class="clickable" icon="pencil-square" variant="info"
                                        @click="openModalEdit(item.id)"></b-icon>
                            </div>
                        </h3>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>


        <b-modal id="modal-users-edit" class="modal" hide-header >
            <form autocomplete="off" v-if="modalData" class="d-block">
                <b-form-group>
                    <label>Jméno</label>
                    <b-form-input
                        v-model="modalData.name"
                        type="text"
                        placeholder=""
                        autocomplete="off"
                        @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>

                <b-form-group>
                    <label>Email</label>
                    <b-form-input
                            v-model="modalData.email"
                            type="email"
                            placeholder="@"
                            autocomplete="off"
                            @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>

                <b-form-group>
                    <label>Tel</label>
                    <b-form-input
                            v-model="modalData.tel"
                            type="text"
                            placeholder="+420"
                            autocomplete="off"
                            @change="updateModalData()"
                    ></b-form-input>
                </b-form-group>

                <b-form-group>
                    <label>Oprávnění</label>
                    <b-form-select
                            v-model="modalData.permission"
                            :options="permissions"
                            @change="updateModalData()">
                    </b-form-select>
                </b-form-group>

                <b-form-group>
                    <b-form-checkbox
                            switch
                            size="lg"
                            v-model="modalData.leader"
                            value="1"
                            @change="updateModalData()">
                        Vedoucí v kroužku
                    </b-form-checkbox>
                </b-form-group>

                <b-button v-b-toggle:my-collapse variant="info" size="sm">
                    Změnit heslo?
                </b-button>
                <b-collapse id="my-collapse" class="my-2">
                    <b-card>
                        <b-form-group>
                            <label>Nové heslo</label>
                            <b-form-input
                                    v-model="password"
                                    type="password"
                                    autocomplete="off"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label>Potvrzení nového hesla</label>
                            <b-form-input
                                    v-model="password2"
                                    type="password"
                                    autocomplete="off"
                            ></b-form-input>
                        </b-form-group>
                        <b-button variant="info" size="sm"  @click="changePassword()">Uložit nové heslo
                        </b-button>
                    </b-card>
                </b-collapse>

                <b-form-group class="text-right">
                    <b-button variant="danger" size="sm"  @click="deleteItem(modalData.id)">Smazat
                        <b-icon icon="trash-fill" ></b-icon>
                    </b-button>
                </b-form-group>
            </form>

            <template v-slot:modal-footer="">
                <b-button block @click="$bvModal.hide('modal-users-edit')">Zavřít</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>

    import axios from 'axios'
    import Navbar from "../components/navbar";
    import MessageController from "../components/message-controller";

    export default {
        name: "users",
        components: {MessageController, Navbar},
        data() {
            return {
                posts: [],
                users: [],
                modalData: Object,
                errors: [],
                changedModalId: null,
                newCommentLog: '',
                permissions: [
                    {value: 'user', text: 'Uživatel'},
                    {value: 'user-2', text: 'Uživatel s právy editace'},
                    {value: 'admin', text: 'Admin'}
                ],
                password: '',
                password2: ''
            }
        },
        methods: {

            changePassword() {
                if (this.password2 === this.password) {
                    this.modalData.password = this.password;
                    this.updateModalData();
                } else {
                    this.$eventHub.$emit('openMessageController', 'error', 'Hesla se neschodují');
                }

            },

            async loadData() {
                try {
                    const response_data = await axios({
                        url: process.env.VUE_APP_SERVER+'users/list.php',
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                        method: 'GET'
                    });

                    this.posts = response_data.data;

                    if (this.changedModalId) {
                        this.changeDataInModal(this.changedModalId);
                    }


                } catch (error) {
                    console.log("error", error);
                    this.$store.dispatch('logout');
                }
            },


            async updateModalData() {
                try {
                    await axios({
                        url: process.env.VUE_APP_SERVER+'users/update-item.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        data: this.modalData,
                        method: 'PUT'
                    });
                    this.loadData();
                    this.$eventHub.$emit('openMessageController', 'success', 'Změna proběhla úspěšně');

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
                }

            },

            async deleteItem(id) {
                try {
                    if (confirm("Opravdu smazat?")) {
                        await axios({
                            url: process.env.VUE_APP_SERVER + 'users/delete-item.php',
                            headers: {'content-type': 'application/x-www-form-urlencoded'},
                            data: {'id': id},
                            method: 'DELETE'
                        });
                        this.$bvModal.hide('modal-users-edit');

                        const index = this.posts.records.findIndex(posts => posts.id === id);
                        this.posts.records.splice(index, 1);


                        this.loadData();
                        this.$eventHub.$emit('openMessageController', 'success', 'Položka byla smazána');
                    }

                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                    this.$eventHub.$emit('openMessageController', 'error', 'Operace se nezdařila');
                }

            },

            async addNewItem() {

                try {
                    const response = await axios({
                        url: process.env.VUE_APP_SERVER+'users/new-item.php',
                        headers: { 'content-type': 'application/x-www-form-urlencoded' },
                        method: 'POST'
                    });

                    // data se načítají ve špatnou chvíli.
                    this.loadData();
                    this.openModalEdit(response.data.id, true);


                } catch (error) {
                    this.loadData();
                    console.log("error", error);
                }

            },

            openModalEdit(itemId) {
                this.changedModalId = itemId;
                this.$bvModal.show('modal-users-edit'); // open bs modal
                this.changeDataInModal(itemId);


            },
            changeDataInModal(itemId) {
                try {
                    this.modalData = this.posts.records.find( ({ id }) => id === itemId );
                } catch(err) {
                    console.log(err);
                }
            },
        },
        created() {
            this.loadData();
        }
    }
</script>

<style scoped lang="scss">
    .table {
        max-width: 100%;
        th, td {
            padding-left: 0;
            padding-right: 0;
        }
    }

    h3.item-wrap {
        color: var(--cyan);
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

    }
    .description {
        color: #6c757d;
        line-height: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;

    }

    .icons {
        font-size: 1.5rem;
        float: right;
        cursor: pointer;
    }

    .badge {
        letter-spacing: .5px;
        font-weight: 500;
        vertical-align: middle;
    }


    .card-body {
        overflow: auto;
        max-height: 300px;
    }


    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .history_list {
        padding: 0;
        margin: 0;
        td {
            color: var(--gray);
            vertical-align: top;
            display: flex;
            flex-direction: column;
        }

        .table-date {
            white-space: nowrap;
        }

        &__row {
             width: 100%;
             flex: 1 0 100%;
             display: flex;
             justify-content: space-between;
         }
    }
</style>
